module.exports = __webpack_public_path__ + "img/serviceDetail_banner.1904ccd.png";